import { adminNavbarAppearanceShared } from "./adminNavbarAppearanceShared";

/** Tema 2 üst çubuk araç ikonları (tim-icons / tetikleyiciler) */
export const THEME2_NAVBAR_TOOLBAR_ICON_PX = 18;
/** Dil seçici (IoLanguageOutline) — diğer toolbar ikonlarından biraz daha büyük */
export const THEME2_NAVBAR_LANGUAGE_ICON_PX = THEME2_NAVBAR_TOOLBAR_ICON_PX + 4;
/** Masaüstü arama kutusundaki büyüteç (toolbar’dan biraz daha küçük) */
export const THEME2_NAVBAR_SEARCH_TRIGGER_ICON_PX = 14;
/** Masaüstü arama tetikleyicisindeki “Search…” metni (px) */
export const THEME2_NAVBAR_SEARCH_PLACEHOLDER_PX = 12;
/** `white-content` (light) üst çubuk ikonları */
export const THEME2_NAVBAR_TOOLBAR_ICON_COLOR_LIGHT = "#738090";
/** Koyu üst çubuk ikonları ve metinleri */
export const THEME2_NAVBAR_TOOLBAR_ICON_COLOR_DARK = "#ffffff";
/** Koyu üst çubuk: açık menü — renk beyaz kalır (vurgu kalınlıkla) */
export const THEME2_NAVBAR_TOOLBAR_ICON_COLOR_ACTIVE_DARK = "#ffffff";
/** Açık üst çubuk: açık menü — açık gri zeminde görünür koyu ikon */
export const THEME2_NAVBAR_TOOLBAR_ICON_COLOR_ACTIVE_LIGHT = "#000000";
export const THEME2_NAVBAR_TOOLBAR_ICON_COLOR_ACTIVE =
  THEME2_NAVBAR_TOOLBAR_ICON_COLOR_ACTIVE_DARK;
/** Koyu üst çubuk hesap metni — normal / açık (hafif bold) */
export const THEME2_NAVBAR_ACCOUNT_TEXT_WEIGHT = 400;
export const THEME2_NAVBAR_ACCOUNT_TEXT_WEIGHT_ACTIVE = 500;

/** Açık üst çubuk: araç tetikleyicisi hover zemin */
export const THEME2_TOOLBAR_TRIGGER_HOVER_BG_LIGHT_SURFACE = "rgba(0, 0, 0, 0.06)";
/** Koyu üst çubuk: araç tetikleyicisi hover zemin */
export const THEME2_TOOLBAR_TRIGGER_HOVER_BG_DARK_SURFACE = "rgba(255, 255, 255, 0.12)";
/** Açık yüzeyde hover ikon rengi */
export const THEME2_TOOLBAR_TRIGGER_HOVER_ICON_LIGHT_SURFACE = "#000000";
/** Koyu yüzeyde hover ikon rengi */
export const THEME2_TOOLBAR_TRIGGER_HOVER_ICON_DARK_SURFACE = "#ffffff";

/** Tema 2 + açık (white-content) üst bar: arama kutusu ve rozet stilleri */
export const theme2NavbarLightSurfaceSearchTokens = {
  searchTrigger: {
    ...adminNavbarAppearanceShared.searchTriggerFrame,
    minHeight: "30px",
    height: "30px",
    padding: "2px 20px 2px 8px",
    maxWidth: "180px",
    backgroundColor: "#F2F1F6",
    border: "1px solid #E5E4E9",
  },
  /** Hover: hesap menüsü ile aynı açık yüzey hover */
  searchTriggerHoverBg: "#f0f0f0",
  searchTriggerDefaultBg: "rgba(0, 0, 0, 0.06)",
  searchIcon: {
    color: THEME2_NAVBAR_TOOLBAR_ICON_COLOR_LIGHT,
    marginRight: "6px",
    fontSize: `${THEME2_NAVBAR_SEARCH_TRIGGER_ICON_PX}px`,
  },
  searchPlaceholder: {
    color: "rgba(0, 0, 0, 0.45)",
    fontSize: `${THEME2_NAVBAR_SEARCH_PLACEHOLDER_PX}px`,
    flex: 1,
    userSelect: "none",
  },
  searchEnterBadge: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    padding: "2px 8px",
    fontSize: "11px",
    fontWeight: "bold",
    color: "rgba(0, 0, 0, 0.55)",
    border: "none",
  },
};

/** Tema 2 — üst bar sınıfları ve arama kutusu ölçüleri (koyu tema: paylaşılan koyu yüzey renkleri) */
export const theme2NavbarAppearance = {
  ...adminNavbarAppearanceShared,
  navbarShellClassNames: {
    "admin-navbar-shell-theme-2": true,
  },
  navbarWrapperShellClassNames: {
    "navbar-wrapper-shell-theme-2": true,
  },
  sidebarToggleClassName: "admin-navbar-shell2-sidebar-trigger",
  desktopSearchNavExtraClassName: "flex-grow-1",
  showSearchEnterBadge: false,
  centerNav: {
    flex: 1,
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "0 16px 0 0",
  },
  searchTrigger: {
    ...adminNavbarAppearanceShared.searchTriggerFrame,
    minHeight: "30px",
    height: "30px",
    padding: "2px 20px 2px 8px",
    maxWidth: "180px",
    /** Koyu mod: çerçeve arka planla aynı renk (hover’da AdminNavbar borderColor senkronu) */
    border: "1px solid rgba(100, 100, 100, 0.2)",
  },
  /** Koyu üst bar: arama kutusu hover/leave’de border’ı background ile aynı tut */
  syncSearchTriggerBorderWithBackground: true,
  /** Koyu üst bar: arama kutusu hover — hesap menüsü satırları ile aynı */
  searchTriggerHoverBg: "#404954",
  searchTriggerDefaultBg: "rgba(100, 100, 100, 0.2)",
  toolbarIconFontSize: `${THEME2_NAVBAR_TOOLBAR_ICON_PX}px`,
  languageToolbarIconFontSize: `${THEME2_NAVBAR_LANGUAGE_ICON_PX}px`,
  toolbarIconColorLight: THEME2_NAVBAR_TOOLBAR_ICON_COLOR_LIGHT,
  toolbarIconColorDark: THEME2_NAVBAR_TOOLBAR_ICON_COLOR_DARK,
  toolbarIconColorActiveLight: THEME2_NAVBAR_TOOLBAR_ICON_COLOR_ACTIVE_LIGHT,
  toolbarIconColorActiveDark: THEME2_NAVBAR_TOOLBAR_ICON_COLOR_ACTIVE_DARK,
  toolbarIconColorActive: THEME2_NAVBAR_TOOLBAR_ICON_COLOR_ACTIVE_DARK,
  searchIcon: {
    ...adminNavbarAppearanceShared.searchIcon,
    color: THEME2_NAVBAR_TOOLBAR_ICON_COLOR_DARK,
    marginRight: "6px",
    fontSize: `${THEME2_NAVBAR_SEARCH_TRIGGER_ICON_PX}px`,
  },
  searchPlaceholder: {
    ...adminNavbarAppearanceShared.searchPlaceholder,
    color: THEME2_NAVBAR_TOOLBAR_ICON_COLOR_DARK,
    fontSize: `${THEME2_NAVBAR_SEARCH_PLACEHOLDER_PX}px`,
    fontWeight: THEME2_NAVBAR_ACCOUNT_TEXT_WEIGHT,
  },
  modalSearchIcon: {
    ...adminNavbarAppearanceShared.modalSearchIcon,
    color: THEME2_NAVBAR_TOOLBAR_ICON_COLOR_DARK,
    fontSize: `${THEME2_NAVBAR_TOOLBAR_ICON_PX}px`,
  },
  modalCloseIcon: {
    color: THEME2_NAVBAR_TOOLBAR_ICON_COLOR_DARK,
    fontSize: `${THEME2_NAVBAR_TOOLBAR_ICON_PX}px`,
  },
  /** Arama modalı — Tema 1’e göre biraz daha dar */
  modalRoot: {
    ...adminNavbarAppearanceShared.modalRoot,
    width: "24%",
    maxWidth: "900px",
  },
  emptyStateIcon: {
    ...adminNavbarAppearanceShared.emptyStateIcon,
    color: THEME2_NAVBAR_TOOLBAR_ICON_COLOR_DARK,
    fontSize: `${THEME2_NAVBAR_TOOLBAR_ICON_PX}px`,
  },
  showNavbarLogoImage: true,
  showNavbarBrandText: true,
  /** logo2.svg — koyu zemin: açık; açık zemin: doğal renk */
  logoImg: {
    filter: "brightness(0) invert(1)",
    height: "26px",
    cursor: "pointer",
  },
  logoImgLightSurface: {
    filter: "none",
    height: "26px",
    cursor: "pointer",
  },
  sidebarTriggerAction: "mini",
};
